export const SUCCESS_PROPERTY_STATUS="SUCCESS_PROPERTY_STATUS";
export const FAILED_PROPERTY_STATUS="FAILED_PROPERTY_STATUS";
export const REQUST_PROPERTY_STATUS="REQUST_PROPERTY_STATUS";
